import type { PhysicalThing } from "./physicalThing";

export class Cell {
	private things: PhysicalThing[] = [];

	addThing(thing: PhysicalThing): void {
		this.things.push(thing);
	}

	removeThing(thing: PhysicalThing): void {
		const index = this.things.indexOf(thing);
		if (index !== -1) {
			this.things.splice(index, 1);
		}
	}

	getThings(): PhysicalThing[] {
		return [...this.things];
	}

	hasThing(thing: PhysicalThing): boolean {
		return this.things.includes(thing);
	}

	isBlocked(): boolean {
		return this.things.some((t) => t.blocksMovement);
	}

	getVisibleDrawables(): PhysicalThing[] {
		const visible = this.things.filter((t) => t.isVisible());
		visible.sort((a, b) => a.getZOrder() - b.getZOrder());

		// Apply isHideUnderneath occlusion: iterate from highest z-order backward.
		// When a thing has isHideUnderneath, nothing below it is visible.
		const result: PhysicalThing[] = [];
		for (let i = visible.length - 1; i >= 0; i--) {
			result.push(visible[i]);
			if (visible[i].isHideUnderneath()) break;
		}

		// Reverse to get low-to-high z-order (back-to-front drawing order)
		result.reverse();
		return result;
	}
}
